enum EBusinessRepresentative {
  HEADER = 'header',
  OTHER = 'other',
}

export default EBusinessRepresentative;
